/**
 * 无多语言白名单权限时，清除本地 en/zh_tw，避免仅靠隐藏菜单被绕过。
 */
export function clampDisallowedI18nAfterUserFetch(i18nSwitchEnabled: number): void {
  if (i18nSwitchEnabled === 1) {
    return;
  }
  let raw = localStorage.getItem('xlanguage');
  if (raw == null || raw === '') {
    return;
  }
  raw = raw.replace(/"/g, '').trim();
  if (raw !== 'en' && raw !== 'zh_tw') {
    return;
  }
  localStorage.setItem('xlanguage', 'zh');
  window.location.reload();
}
